export const getMonthStart = (date) =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    1
  );

export const getNextMonth = (date) =>
  new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    1
  );

export const getInitialMonths = (numberOfMonths = 3) => {
  const currentMonth = getMonthStart(new Date());

  return Array.from(
    { length: numberOfMonths },
    (_, index) => {
      const month = new Date(currentMonth);
      month.setMonth(
        currentMonth.getMonth() + index
      );

      return month;
    }
  );
};

function formatTime(date) {
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export default formatTime;